export default __webpack_public_path__ + "a8a93317355523aeb54c4734a1f0d86c.png";